import { jsx as _jsx } from "react/jsx-runtime";
import { DateTime } from 'luxon';
import { useMemo } from 'react';
export const CardFooter = (param)=>{
    let { updatedAt, deletedAt } = param;
    const relativeDate = useMemo(()=>{
        var _ref;
        var _format;
        const format = (dateStr)=>DateTime.fromISO(dateStr, {
                locale: 'en'
            }).toRelative();
        if (deletedAt) {
            var _ref1;
            var _format1;
            return "Deleted ".concat((_ref1 = (_format1 = format(deletedAt)) === null || _format1 === void 0 ? void 0 : _format1.toString()) !== null && _ref1 !== void 0 ? _ref1 : '');
        }
        return updatedAt ? "Updated ".concat((_ref = (_format = format(updatedAt)) === null || _format === void 0 ? void 0 : _format.toString()) !== null && _ref !== void 0 ? _ref : '') : '';
    }, [
        deletedAt,
        updatedAt
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center pt-3",
        "data-e2e": "card-footer",
        children: (!!updatedAt || !!deletedAt) && /*#__PURE__*/ _jsx("div", {
            className: "cursor-default",
            children: /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-muted-foreground",
                children: relativeDate
            })
        })
    });
};
